import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.YourVoice.title',
    defaultMessage: 'Help us find the best jobs for your voice',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.YourVoice.subtitle',
    defaultMessage: 'Your voice is your fingerprint. For us to match it with the right jobs and clients, we need to know how you sound like. Please try your best to describe your voice so that we can ensure it matches the clients’ expectations.barraenebarraenePlease note we only ask you to enter languages you’re fully native in. If you have any additional accents, you’ll be able to let us know later.',
  },
  descriptionLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.description.label',
    defaultMessage: 'How would you describe your voice?',
  },
  descriptionLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.description.label.hint',
    defaultMessage: 'Include short, precise characteristics and additional dialects, if any. This may be included on your VoiceArchive\'s public profile.',
  },
  descriptionPlaceholder: {
    id: 'containers.SupplierProfile.components.YourVoice.description.placeholder',
    defaultMessage: 'Enter description here',
  },
  descriptionHint: {
    id: 'containers.SupplierProfile.components.YourVoice.description.hint',
    defaultMessage: '{left} characters left of {max}',
  },
  toneOfVoiceTagsLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.toneOfVoiceTags.label',
    defaultMessage: 'Tone of voice.',
  },
  toneOfVoiceTagsHint: {
    id: 'containers.SupplierProfile.components.YourVoice.toneOfVoiceTags.hint',
    defaultMessage: 'Please select 1-3 of the following tones that describes your voice the best',
  },
  voiceAgesLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceAges.label',
    defaultMessage: 'What voice ages can you perform exceptionally well?',
  },
  voiceAgesLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceAges.label.hint',
    defaultMessage: 'Select a maximum of two voice ages.',
  },
  voiceAgesExampleLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceAges.example.label',
    defaultMessage: 'Example',
  },
  voiceAgesExampleTitle: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceAges.example.title',
    defaultMessage: 'Click here to listen to an example of this voice age',
  },
  voiceGenderLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceGender.label',
    defaultMessage: 'How does your voice sound?',
  },
  voiceGenderLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.voiceGender.label.hint',
    defaultMessage: 'We\'re asking about the qualities of your voice.',
  },
  childLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.child.label',
    defaultMessage: 'Child (< 10)',
  },
  youngLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.young.label',
    defaultMessage: 'Young (10-20)',
  },
  adultLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.adult.label',
    defaultMessage: 'Adult (21-65)',
  },
  seniorLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.senior.label',
    defaultMessage: 'Senior (65+)',
  },
  maleGenderLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.maleGender.label',
    defaultMessage: 'Male',
  },
  femaleGenderLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.femaleGender.label',
    defaultMessage: 'Female',
  },
  otherGenderLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.otherGender.label',
    defaultMessage: 'Non binary',
  },
  otherGenderWarning: {
    id: 'containers.SupplierProfile.components.YourVoice.otherGender.warning',
    defaultMessage: 'Selecting androgynous might result in fewer job possibilities. Customers, looking for voice-over artists, are usually enabling filtering explicitly searching for male or female voices. Consider this option, only if you think of your voice as completely indistinguishable. barraenebarraeneYou can add additional details about your voice in the comment box on this same page.',
  },
  languagesLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.languages.label',
    defaultMessage: 'Select the native language you are fully fluent in.',
  },
  languagesLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.languages.label.hint',
    defaultMessage: 'This language will be publicly displayed. You should be a 100% profficient in this language.',
  },
  languagesWarning: {
    id: 'containers.SupplierProfile.components.YourVoice.languages.warning',
    defaultMessage: 'You must select a native language.',
  },
  secondaryLanguagesLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.languages.secondary.label',
    defaultMessage: 'Select up to 2 secondary languages that you are proficient in',
  },
  secondaryLanguagesLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.languages.secondary.label.hint',
    defaultMessage: 'These languages won\'t be displayed on the public website, but will be considered for i.e. phone prompts, etc.',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.YourVoice.validationFailed',
    defaultMessage: 'You have not filled out all the required fields. Please return to the \'Your Voice\' step and fill out all fields.',
  },
  birthdayLabel: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.label',
    defaultMessage: 'When were you born?',
  },
  birthdayLabelHint: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.label.hint',
    defaultMessage: 'We need it for your birthday wishes and to assess the age of your voice. ',
  },
  birthdayDayPlaceholder: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.day.placeholder',
    defaultMessage: 'Day',
  },
  birthdayMonthPlaceholder: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.month.placeholder',
    defaultMessage: 'Month',
  },
  birthdayMonthOptions: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.month.options',
    defaultMessage: 'January,February,March,April,May,June,July,August,September,October,November,December',
  },
  birthdayYearPlaceholder: {
    id: 'containers.SupplierProfile.components.YourVoice.birthday.year.placeholder',
    defaultMessage: 'Year',
  },
})
